import {ProductDetailsSection as ProductDetailsSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/product_details.types';
import {FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {useArticleNumberFromProductDetailResponse} from '../ProductDetails/shared/useArticleNumberFromProductDetailResponse';
import {SizeChartComponentProps} from '../SizeCharts/SizeCharts';
import {ProductDetailAccordion} from './Accordions/ProductDetailAccordion';

export interface ProductDetailsAccordionProps extends SizeChartComponentProps {
  className?: string;
  selectedSize: SelectedSize;
  showProductName?: boolean;
  renderingPriority?: number;
}

export const ProductDetailsAccordionsView: React.FC<
  ProductDetailsAccordionProps &
    ProductDetailsSectionType & {
      className?: string;
    }
> = ({
  articleDetails,
  selectedSize,
  showProductName,
  SizeChartLayout,
  SizeSystemLayout,
  className,
}) => {
  const articleNumber = useArticleNumberFromProductDetailResponse(
    articleDetails,
    {
      selectedSize,
    },
  );

  if (!articleDetails) {
    return null;
  }

  return (
    <Wrapper className={className} data-testid="productDetailsAccordions">
      {showProductName && (
        <ProductName data-testid="productName">
          {articleDetails.productName}
        </ProductName>
      )}
      {articleDetails.lanes.map((section, index) => (
        <ProductDetailAccordion
          key={`product-details-accordion-${index}`}
          articleNumber={articleNumber}
          section={section}
          SizeChartLayout={SizeChartLayout}
          SizeSystemLayout={SizeSystemLayout}
        />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow-x: hidden;
`;

const ProductName = styled.h1`
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.w400};
  margin: 0 0 1rem 0;
`;
